import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.824 2.667H3.491a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2M3.491 12a.667.667 0 0 1-.667-.667V9.72l2.2-2.193a.667.667 0 0 1 .934 0L10.43 12zm10-.667a.667.667 0 0 1-.667.667h-.513l-2.54-2.553.587-.587a.667.667 0 0 1 .933 0l2.2 2.193zm0-2.16-1.253-1.247a2.04 2.04 0 0 0-2.827 0l-.587.587-1.92-1.92a2.04 2.04 0 0 0-2.826 0L2.824 7.84V4.667A.667.667 0 0 1 3.491 4h9.333a.667.667 0 0 1 .667.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })